import { ThemeProvider } from '@mui/material/styles';
import { LicenseInfo } from '@mui/x-license-pro';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import ReactDOM from 'react-dom/client';
import App from './App';
import disableConsoleInProduction from './disableConsole';
import './index.css';
import './i18n';
import reportWebVitals from './reportWebVitals';
import './variable.css';

LicenseInfo.setLicenseKey(
  'b1e4a569e1a19d9b5511a48560c24b2eTz0xMTc5NDIsRT0xNzg3MjcwMzk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1RMy0yMDI0LEtWPTI='
);

disableConsoleInProduction();
init({
  dsn: import.meta.env.VITE_APP_SENTRY_DSN,
  integrations: [browserTracingIntegration(), replayIntegration()],
  // Performance Monitoring
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/api.digitalpaani\.com\//],
  // Session Replay
  replaysSessionSampleRate: 0.01, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

import { PostHogProvider } from 'posthog-js/react';
import Theme from './core-components/theme/theme';
import { browserTracingIntegration, init, replayIntegration } from '@sentry/react';

const options = {
  api_host: import.meta.env.VITE_POSTHOG_ENDPOINT,
  autocapture: false,
  capture_pageview: false,
  capture_pageleave: false,
  capture_web_vitals: false,
  capture_performance: false
}

export const queryClient = new QueryClient();
ReactDOM.createRoot(document.getElementById('root')!).render(
    <QueryClientProvider client={queryClient}>
    <PostHogProvider apiKey={import.meta.env.VITE_POSTHOG_TOKEN} options={options}>
    <ThemeProvider theme={Theme}>
        <App />
      </ThemeProvider>
    </PostHogProvider>
      <ReactQueryDevtools initialIsOpen={true} />
    </QueryClientProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();